import { create } from "zustand";

type State = {
  deviceToken: string;
  resourceEndpoint: string;
};

const useNativeStore = create<State>((_set, _get) => ({
  deviceToken: "",
  resourceEndpoint: window.__WEBVIEW_CONFIG__?.resourceEndpoint ?? "",
}));

export const getDeviceToken = async (): Promise<string> => {
  return new Promise((resolve) => {
    const deviceToken = useNativeStore.getState().deviceToken;
    if (deviceToken) {
      resolve(deviceToken);
      return;
    }
    const unsubscribe = useNativeStore.subscribe((state) => {
      if (state.deviceToken) {
        resolve(state.deviceToken);
        unsubscribe();
      }
    });
  });
};

export const clearDeviceToken = () => {
  useNativeStore.setState({ deviceToken: "" });
};

export const setDeviceToken = (token: string) => {
  useNativeStore.setState({ deviceToken: token });
};

export const getResourceEndpoint = () => {
  return useNativeStore.getState().resourceEndpoint;
};

export const setResourceEndpoint = (resourceEndpoint: string) => {
  useNativeStore.setState({ resourceEndpoint });
};
export default useNativeStore;
